module.exports = __webpack_public_path__ + "media/images/discover/offers/digital-voucher-2be608e3beaedf55801229042ed277ad.jpg";